/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class SetsIcon extends BaseIcon {
  getChildren = () => [ <g fill={ this.getColor() }>
    <rect width="1" height="4"/>
    <rect width="4" height="1"/>
    <rect x="15" width="1" height="4"/>
    <rect x="12" width="4" height="1"/>
    <rect y="12" width="1" height="4"/>
    <rect y="15" width="4" height="1"/>
    <rect x="15" y="12" width="1" height="4"/>
    <rect x="12" y="15" width="4" height="1"/>
    <path d="M8,4a4,4,0,1,0,4,4A4,4,0,0,0,8,4Z"/>
  </g> ]
  getViewBox = () => '0 0 16 16'
}
